import React, { useEffect } from 'react';
import fhatuPic from "../assets/photo2.jpg";
import { themeChange } from 'theme-change'
import "../index.css";

const aboutBg = {
  backgroundColor: 'var(--aboutBg)'
}

const skillBg = {
  backgroundColor: 'var(--about-bg)'
}
const About = (props) => {

  const handleClickScroll = (val) => {
    const element = document.getElementById(val);
    
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    themeChange(false)
    // 👆 false parameter is required for react project
  }, [])

  return (
    <section className={`w-full glass px-4 py-16`} id={props.id}>

      <div className='card mb-4 shadow-2xl text-center flex mx-auto justify-center lg:flex-column w-full rounded glass'>
        <div className='rounded text-white' style={skillBg}>
          <h2 className="p-5 text-4xl font-bold">
            About Me.
          </h2>
          <p className="font-bold">
           Brief Introduction About My Career.
          </p>
        </div>
      </div>

      <div className="flex gap-2 flex-col w-full lg:flex-row" style={aboutBg}>
        <div className="card gap-1 justify-between flex-col flex-shrink-0 w-full max-w-sm  shadow-2xl rounded" style={aboutBg}>
          <div>
            <img
              src={fhatuPic}
              alt="Album"
              className="rounded aboutImg"
            />
          </div>

          <div className="card-actions text-black flex align-end w-full align-end rounded relative bottom-0 left-0">
            <div className="form-control w-full">
              <button onClick={() => handleClickScroll("contact")} className="rounded btn btn-primary">Request CV</button>
            </div>
          </div>
        </div>
        <div className="divider lg:divider-horizontal"></div>

        <div className="grid flex-grow h-fit card rounded-box place-items-center" style={aboutBg}>
          <div className='rounded text-white py-4 px-4' style={skillBg}>
            <h2 className="card-title text-center p-5 text-lg font-bold">
              A Bit About Me.
            </h2>
            <p className="font-bold">
              I am a full stack software developer with 1 year of working
              experience in fields like frontend, backend, databases and APIs. I
              combine my interpersonal skills with technical skills and fully
              commit to consistency in meeting deadlines. I utilize all
              available resources and learn new technologies to achieve results.
              I enjoy creating beautiful, accessible, and responsive websites
              using HTML, CSS, Bootstrap, Angular, SCSS, Vanilla JavaScript, and
              React. Effective use of time, problem-solving and communication
              skills help me show a positive attitude in complex situations. I
              have passion for learning and my desire to learn quickly adapts me
              to changing situations.
            </p>
          </div>

          <div className='w-full'>
            <div className="flex flex-col w-full text-white lg:flex-row gap-2 mt-3">
              <div className="grid flex-grow h-80 card bg-blue-300 rounded place-items-center ">
                <h3 className="card-title text-center p-3 text-4xl font-bold">
                  Current Position.
                </h3>
                <ul className="text-center text-2xl">
                  <li>Digital Solution Foundry</li>
                  <li>Software Developer Intern</li>
                  <li>Started March 2023</li>
                  <li>Sunnyside Office Park, Parktown, Johannesburg</li>
                </ul>
              </div>
              <div className="divider lg:divider-horizontal"></div>
              <div className="grid flex-grow h-80 card text-white rounded-lg bg-blue-300 place-items-center">
                <h3 className="card-title text-center p-2 text-4xl font-bold">
                  Education.
                </h3>
                <ul className="text-center text-2xl">
                  <li>University of Limpopo</li>
                  <li>BSc Mathematical Sciences</li>
                  <li>Completed 2019</li>
                  <li>Polokwane, Limpopo</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}

export default About;
